<template>
  <section class="simulados">
    <div class="lista-simulados container">
      <div>
        <b-tabs pills nav-class="mb-1 mb-lg-0 abas-lista-sim nav-fill">
          <template slot="tabs-start">
            <div class="col-12 text-center text-md-left pb-5">
              <div class="d-flex align-items-center justify-content-md-start">
                <i class="mdi mdi-frequently-asked-questions"></i>&nbsp;
                <span class="ml-2 header-simulado-lista">
                  {{ configEmpresa.textosConfiguraveis.textoDisplaySimulados }}
                </span>
              </div>
            </div>
          </template>

          <b-tab title-item-class="bg-white" active>
            <template slot="title">Novo {{ configEmpresa.textosConfiguraveis.textoDisplaySimulado }}</template>

            <simulados-empresa />
          </b-tab>
          <b-tab title-item-class="bg-white">
            <template slot="title">Em progresso</template>

            <meus-simulados />
          </b-tab>
          <b-tab title-item-class="bg-white">
            <template slot="title">Finalizados</template>

            <meus-simulados :finalizados="true" />
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </section>
</template>

<script>
import MeusSimulados from '@/modules/Simulados/components/MeusSimulados'
import SimuladosEmpresa from '@/modules/Simulados/components/SimuladosEmpresa'

export default {
  name: 'ListaSimuladosView',
  components: { SimuladosEmpresa, MeusSimulados },
  mounted () {
    this.verificaAcessoEmpresaSimulado()
  },
  computed: {
    configEmpresa: function () {
      return this.$store.getters.empresa
    },
    empresaComAcessoSimulado: function () {
      return this.$empresaUtils.temAcesso(this.$tipoAcesso.HEADER_SIMULADOS.nome, this.$configEmpresa.rotasRestritasAcesso)
    }
  },
  methods: {
    verificaAcessoEmpresaSimulado () {
      if (!this.empresaComAcessoSimulado) {
        return this.$router.push(`/home`)
      }
    }
  }
}
</script>

<style scoped>

</style>
